import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 综合性运动会
import compreSportsMeetRouter from '@router/compreSportsMeet/commonRouter'
// 大运会
import compreSportsMeet_universiadeRouter from '@router/compreSportsMeet/universiade'
// 亚运会
import compreSportsMeet_asianGamesRouter from '@router/compreSportsMeet/asianGames'
// 奥运会
import compreSportsMeet_olympicGamesRouter from '@router/compreSportsMeet/olympicGames'
// 米兰冬奥会
import compreSportsMeet_milanWinterGamesRouter from '@router/compreSportsMeet/milanWinterGames'
// 亚冬会
import compreSportsMeet_asianWinterGamesRouter from '@router/compreSportsMeet/asianWinterGames'
// 全运会
import compreSportsMeet_nationalGamesRouter from '@router/compreSportsMeet/nationalGames'

const {
  CSMeetRegularScheduleIndex,
  CSMeetEventPlayersScheduleIndex,
  CSMeetEventPhaseIndex,
  CSMeetMedalTallyIndex,
  CSMeetMedalDetailListIndex,
  CSMeetBigSportsIndex,
  CSMeetSportsDetailIndex,
  CSMeetSportsDetailScheduleDate,
  CSMeetSportDetailScheduleDetail,
  CSMeetSportDetailScheduleDetailStartList,
  CSMeetSportDetailScheduleDetailLocalData,
  CSMeetSportDetailScheduleDetailDataAnalysis,
  CSMeetSportDetailScheduleDetailDataBattleReport,
  CSMeetSportsDetailPlayer,
  CSMeetSportsDetailCompreScore,
  CSMeetSportsDetailMedalList,
  CSMeetSportsDetailEventDataAnalysis,
  CSMeetDelegationIndex,
  CSMeetDelegationDetailIndex,
  CSMeetDelegationDetailSchedule,
  CSMeetDelegationDetailPlayer,
  CSMeetDelegationDetailMedalList,
  CSMeetPlayerIndex,
  CSMeetPlayerDetailIndex,
  CSMeetRecordIndex,
  CSMeetBroadcastListIndex,
  CSMeetDataPackagListIndex,
  CSMeetProgramListIndex,
  CSMeetVenueIndex,
  CSMeetSportDetailScheduleDetailOtherTab_combinedResult,
  CSMeetSportDetailScheduleDetailOtherTab_singleResult,
  CSMeetSportDetailScheduleDetailOtherTab_compreResult,
  CSMeetSportDetailScheduleDetailOtherTab_teamResult,
  CSMeetSportDetailScheduleDetailOtherTab_groupResult,
} = compreSportsMeetRouter
const { PlatfromCSMeetUniversiadeFull } = compreSportsMeet_universiadeRouter
const { PlatfromCSMeetAsianGamesFull } = compreSportsMeet_asianGamesRouter
const { PlatfromCSMeetOlympicGamesFull } = compreSportsMeet_olympicGamesRouter
const { PlatfromCSMeetMilanWinterGamesFull } =
  compreSportsMeet_milanWinterGamesRouter
const { PlatfromCSMeetAsianWinterGamesFull } =
  compreSportsMeet_asianWinterGamesRouter
const { PlatfromCSMeetNationalGamesFull } = compreSportsMeet_nationalGamesRouter

const pathModuleBase = 'platfromCSMeetFull'
const diffCompetitionTypeArr = [
  {
    name: 'WUSG',
    pathModule: 'universiades',
    component: PlatfromCSMeetUniversiadeFull,
  }, // 大运会
  {
    name: 'ASG',
    pathModule: 'asianGames',
    component: PlatfromCSMeetAsianGamesFull,
  }, // 亚运会
  {
    name: 'SOG',
    pathModule: 'olympicGames',
    component: PlatfromCSMeetOlympicGamesFull,
  }, // 奥运会
  {
    name: 'AWG',
    pathModule: 'asianWinterGames',
    component: PlatfromCSMeetAsianWinterGamesFull,
  }, // 亚冬会
  {
    name: 'NSG',
    pathModule: 'nationalGames',
    component: PlatfromCSMeetNationalGamesFull,
  }, // 全运会
  {
    name: 'WOG',
    pathModule: 'milanWinterGames',
    component: PlatfromCSMeetMilanWinterGamesFull,
  }, // 米兰冬奥会
]

const baseChildren = [
  // pathModule 默认占位是大运会
  {
    path: 'regularSchedule', //赛程-常规赛程
    name: 'CSMeetRegularScheduleIndex', // 最终生成的name是 CSMeetRegularScheduleIndex_WUSG
    component: CSMeetRegularScheduleIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'schedule'], // pathModule[1]是动态变化
      requireLogin: false,
      title: '赛程-常规赛程',
    },
  },
  {
    path: 'playersSchedule', //赛程-运动员赛程
    name: 'CSMeetEventPlayersScheduleIndex',
    component: CSMeetEventPlayersScheduleIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'schedule'],
      requireLogin: false,
      title: '赛程-运动员赛程',
    },
  },
  {
    path: 'eventPhase', //赛程-项目阶段
    name: 'CSMeetEventPhaseIndex',
    component: CSMeetEventPhaseIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'schedule'],
      requireLogin: false,
      title: '赛程-项目阶段',
    },
  },
  {
    path: 'bigSports', //项目列表
    name: 'CSMeetBigSportsIndex',
    component: CSMeetBigSportsIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
      requireLogin: false,
      title: '项目',
    },
  },
  {
    path: 'sportsDetail', //项目详情
    redirect: { name: 'CSMeetSportsDetailScheduleDate' },
    name: 'CSMeetSportsDetailIndex',
    component: CSMeetSportsDetailIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
      requireLogin: false,
    },
    children: [
      {
        path: 'scheduleDate', //项目详情-赛程
        name: 'CSMeetSportsDetailScheduleDate',
        component: CSMeetSportsDetailScheduleDate,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛程',
        },
      },
      {
        path: 'player', //项目详情-参赛名单
        name: 'CSMeetSportsDetailPlayer',
        component: CSMeetSportsDetailPlayer,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目参赛名单',
        },
      },
      {
        path: 'compreScore', //项目详情-综合成绩
        name: 'CSMeetSportsDetailCompreScore',
        component: CSMeetSportsDetailCompreScore,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目综合成绩',
        },
      },
      {
        path: 'medalList', //项目详情-奖牌
        name: 'CSMeetSportsDetailMedalList',
        component: CSMeetSportsDetailMedalList,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目奖牌',
        },
      },
      {
        path: 'eventDataAnalysis', //项目详情-赛会数据分析（大小项）
        name: 'CSMeetSportsDetailEventDataAnalysis',
        component: CSMeetSportsDetailEventDataAnalysis,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛会数据分析',
        },
      },
    ],
  },
  {
    path: 'scheduleDetail', //赛程详情
    name: 'CSMeetSportDetailScheduleDetail',
    component: CSMeetSportDetailScheduleDetail,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
      requireLogin: false,
    },
    children: [
      {
        path: 'startList', //出场名单
        name: 'CSMeetSportDetailScheduleDetailStartList',
        component: CSMeetSportDetailScheduleDetailStartList,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'localData', //本次数据
        name: 'CSMeetSportDetailScheduleDetailLocalData',
        component: CSMeetSportDetailScheduleDetailLocalData,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'dataAnalysis', //数据分析
        name: 'CSMeetSportDetailScheduleDetailDataAnalysis',
        component: CSMeetSportDetailScheduleDetailDataAnalysis,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'dataBattleReport', //数据分析
        name: 'CSMeetSportDetailScheduleDetailDataBattleReport',
        component: CSMeetSportDetailScheduleDetailDataBattleReport,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'combinedResult', //体操-全能成绩
        name: 'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
        component: CSMeetSportDetailScheduleDetailOtherTab_combinedResult,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'singleResult', //体操-单项成绩
        name: 'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
        component: CSMeetSportDetailScheduleDetailOtherTab_singleResult,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'compreResult', //通用-综合成绩
        name: 'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
        component: CSMeetSportDetailScheduleDetailOtherTab_compreResult,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'teamResult', //通用-团体成绩|混合成绩
        name: 'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
        component: CSMeetSportDetailScheduleDetailOtherTab_teamResult,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'groupResult', //通用-小组成绩|轮次成绩
        name: 'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
        component: CSMeetSportDetailScheduleDetailOtherTab_groupResult,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'bigSports'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
    ],
  },
  {
    path: 'delegation', //代表团
    name: 'CSMeetDelegationIndex',
    component: CSMeetDelegationIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'delegation'],
      requireLogin: false,
      title: '代表团',
    },
  },
  {
    path: 'delegationDetail', //代表团详情
    redirect: { name: 'CSMeetDelegationDetailSchedule' },
    name: 'CSMeetDelegationDetailIndex',
    component: CSMeetDelegationDetailIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'delegation'],
      requireLogin: false,
    },
    children: [
      {
        path: 'schedule', //代表团详情-赛程
        name: 'CSMeetDelegationDetailSchedule',
        component: CSMeetDelegationDetailSchedule,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'delegation'],
          requireLogin: false,
          title: '代表团详情',
        },
      },
      {
        path: 'player', //代表团详情-参赛选手
        name: 'CSMeetDelegationDetailPlayer',
        component: CSMeetDelegationDetailPlayer,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'delegation'],
          requireLogin: false,
          title: '代表团详情',
        },
      },
      {
        path: 'medalList', //代表团详情-获奖明细
        name: 'CSMeetDelegationDetailMedalList',
        component: CSMeetDelegationDetailMedalList,
        meta: {
          pathModule: ['compreSportsMeet', 'universiades', 'delegation'],
          requireLogin: false,
        },
      },
    ],
  },
  {
    path: 'player', //运动员
    name: 'CSMeetPlayerIndex',
    component: CSMeetPlayerIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'player'],
      requireLogin: false,
      title: '运动员',
    },
  },
  {
    path: 'playerDetail', //运动员详情
    name: 'CSMeetPlayerDetailIndex',
    component: CSMeetPlayerDetailIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'player'],
      requireLogin: false,
      title: '运动员详情',
    },
  },
  {
    path: 'medalTally', //奖牌榜
    name: 'CSMeetMedalTallyIndex',
    component: CSMeetMedalTallyIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'medal'],
      requireLogin: false,
      title: '奖牌榜',
    },
  },
  {
    path: 'medalDetailList', //奖牌明细
    name: 'CSMeetMedalDetailListIndex',
    component: CSMeetMedalDetailListIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'medal'],
      requireLogin: false,
      title: '奖牌明细',
    },
  },
  {
    path: 'record', //纪录
    name: 'CSMeetRecordIndex',
    component: CSMeetRecordIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'record'],
      requireLogin: false,
      title: '纪录',
    },
  },
  {
    path: 'venue', //场馆
    name: 'CSMeetVenueIndex',
    component: CSMeetVenueIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'venue'],
      requireLogin: false,
      title: '场馆',
    },
  },
  {
    path: 'broadcastList', //播出单
    name: 'CSMeetBroadcastListIndex',
    component: CSMeetBroadcastListIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //数据包装
    name: 'CSMeetDataPackagListIndex',
    component: CSMeetDataPackagListIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'CSMeetProgramListIndex',
    component: CSMeetProgramListIndex,
    meta: {
      pathModule: ['compreSportsMeet', 'universiades', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

console.debug(
  'finallyChildrenRouterModeArr csMeet:',
  finallyChildrenRouterModeArr
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /universiades
  name: `${pathModuleBase}_${routerItem.name}`, // platfromCSMeetFull_WUSG
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default {
  compreSportsMeet_WUSG_RouterMode: routerModeArr[0],
  compreSportsMeet_ASG_RouterMode: routerModeArr[1],
  compreSportsMeet_SOG_RouterMode: routerModeArr[2],
  compreSportsMeet_AWG_RouterMode: routerModeArr[3],
  compreSportsMeet_NSG_RouterMode: routerModeArr[4],
  compreSportsMeet_WOG_RouterMode: routerModeArr[5],
}
